import React from 'react';
import { HelmetProvider } from 'react-helmet-async';  // Import HelmetProvider
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home'
import ContactUs from './pages/ContactUs'
import AboutUs from './pages/AboutUs'; 
import Product from './pages/Product';
import './App.css';
import './css/main.css';
import Mechanical from './pages/Mechanical';
import Telicom from './pages/Telecom';
import GeneralCategory from './pages/GeneralCategory';
import SaftyItems from './pages/SaftyItems';
import Electrical from './pages/Electrical';
import Instrumentation from './pages/Insrumentation';
const App: React.FC = () => {
  return (
    <HelmetProvider> {/* Wrap your app with HelmetProvider */}
      <Router>
      <div className="maincontainer">
      <div className="maincontent">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
           <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/products" element={<Product />} /> 
          <Route path="/products/Instrumentation/:category" element={<Instrumentation />} />
          <Route path="/products/Instrumentation" element={<Instrumentation />} />
          <Route path="/products/Mechanical/:category" element={<Mechanical />} />
          <Route path="/products/Mechanical" element={<Mechanical />} />
          <Route path="/products/Electrical/:category" element={<Electrical />} />
          <Route path="/products/Electrical" element={<Electrical />} />
          <Route path="/products/Telecom System/:category" element={<Telicom />} />
          <Route path="/products/Telecom System" element={<Telicom />} />
          <Route path="/products/General Category/:category" element={<GeneralCategory />} />
          <Route path="/products/General Category" element={<GeneralCategory />} />
          <Route path="/products/Safety Items" element={<SaftyItems />} />
          <Route path="/products/Safety Items/:category" element={<SaftyItems />} />
        </Routes>
        </div>
        <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
